import { GroupableSettings, PagerSettings } from "@progress/kendo-angular-grid";
import { State } from "@progress/kendo-data-query";
import { FilterExpression } from "@progress/kendo-angular-filter";

import { ColumnSettings } from "./column-settings.interface";

export interface GridConfig {
    state: State;
    columns: ColumnSettings[];
    pager: PagerSettings;
    groupable: GroupableSettings;
    filterExpressions: FilterExpression[];
};
